import ActivityTreeBuilder, { isEmpty, toChangeTypeFromValues, type RevisionLike } from 'utils/activity/ActivityTreeBuilder'

type WorkOrderRevision = RevisionLike & {
  invoiceStatus?: string | null
  workOrderSequence?: string | null
}

type Payload = { workOrdersById?: Record<string, WorkOrderRevision[]> }

/**
 * One row per work order, tagged with its number. Envers opens one revision per transaction, so a
 * bulk mark-ready groups all its work orders under one entry — that grouping is what marks it bulk.
 */
export default function workOrderInvoiceStatusBuilder(builder: ActivityTreeBuilder, payload: unknown = {}): void {
  const { workOrdersById = {} } = (payload && typeof payload === 'object' ? payload : {}) as Payload

  Object.values(workOrdersById).forEach(revisions => {
    if (!Array.isArray(revisions)) return
    const sorted = [...revisions].sort((a, b) => Number(a?.rev ?? 0) - Number(b?.rev ?? 0))

    sorted.forEach((current, index) => {
      const previous = sorted[index - 1]
      // No prior revision means this is the status the work order was created with, not a change.
      if (!previous) return

      const oldValue = previous?.invoiceStatus
      const newValue = current?.invoiceStatus
      if (oldValue === newValue) return
      if (isEmpty(oldValue) && isEmpty(newValue)) return

      builder.addCustomChange(current?.rev ?? index, current, {
        field: 'Work Order - Invoice Status',
        fieldKey: 'invoiceStatus',
        oldValue,
        newValue,
        changeType: toChangeTypeFromValues(oldValue, newValue),
        workOrderNumber: current?.workOrderSequence ?? previous?.workOrderSequence ?? null,
      })
    })
  })
}
